var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBitcoinRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.94 11.95-1.21-1.21-1.21 1.21c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L2.2 9.15c.29-.29.77-.29 1.06 0L5 10.89c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22zM20.73 14.85l-1.74-1.74a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.21 1.21 1.21-1.21c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1.74 1.74c-.14.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.51 14.32V12c0-4.69-3.82-8.51-8.51-8.51-2.59 0-5.01 1.16-6.64 3.19-.26.32-.73.37-1.05.12a.748.748 0 0 1-.12-1.05A9.945 9.945 0 0 1 12 2c5.52 0 10.01 4.49 10.01 10.01v2.32c0 .4-.33.74-.75.74-.41 0-.75-.34-.75-.75zM1.99 12V9.68c0-.41.34-.75.75-.75s.75.34.75.75V12c0 4.69 3.82 8.51 8.51 8.51 2.59 0 5.01-1.16 6.64-3.19a.748.748 0 0 1 1.17.93A9.955 9.955 0 0 1 12 22.01C6.48 22.01 1.99 17.52 1.99 12z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75c-.41 0-.75-.34-.75-.75V8.5c0-.41.34-.75.75-.75h4.38c1.33 0 2.5 1.17 2.5 2.5 0 1.38-1.13 2.5-2.5 2.5H9zm4.37-1.5c.55 0 1-.45 1-1 0-.45-.45-1-1-1H9.75v2h3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.25c-.41 0-.75-.34-.75-.75V12c0-.41.34-.75.75-.75h5c1.52 0 2.75 1.12 2.75 2.5s-1.23 2.5-2.75 2.5H9zm5-1.5c.69 0 1.25-.45 1.25-1s-.56-1-1.25-1H9.75v2H14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 17.25V15.5c0-.41.34-.75.75-.75s.75.34.75.75v1.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM11.05 8.5V6.75c0-.41.34-.75.75-.75s.75.34.75.75V8.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBitcoinRefresh);
export default __webpack_public_path__ + "static/media/vuesax-outline-bitcoin-refresh.0f7629745248b676f79dc1648e9c4e01.svg";
export { ForwardRef as ReactComponent };